"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_core_1 = require("@patternfly/react-core");
const react_1 = tslib_1.__importStar(require("react"));
const ReviewSummary_1 = require("../clusterConfiguration/review/ReviewSummary");
const featureSupportLevels_1 = require("../featureSupportLevels");
require("./ClusterSummaryExpandable.css");
const ClusterSummaryExpandable = ({ cluster }) => {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_core_1.ExpandableSection, { toggleContent: "Cluster summary", onToggle: () => setIsExpanded(!isExpanded), isExpanded: isExpanded, className: "cluster-summary-expandable", id: "cluster-summary-expandable" },
        react_1.default.createElement("div", { className: "pf-v5-u-pl-md pf-v5-u-pt-md" },
            react_1.default.createElement(featureSupportLevels_1.ClusterFeatureSupportLevelsDetailItem, { cluster: cluster }),
            react_1.default.createElement(ReviewSummary_1.ReviewSummaryContent, { cluster: cluster }))));
};
exports.default = ClusterSummaryExpandable;
//# sourceMappingURL=ClusterSummaryExpandable.js.map